import { render } from "./EcosystemOpportunities.vue?vue&type=template&id=33d6eb20&scoped=true"
import script from "./EcosystemOpportunities.vue?vue&type=script&lang=js"
export * from "./EcosystemOpportunities.vue?vue&type=script&lang=js"

import "./EcosystemOpportunities.vue?vue&type=style&index=0&id=33d6eb20&scoped=true&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6eb20"]])

export default __exports__